import * as yup from 'yup';

const credentialsSchema = yup.object().shape({
  email: yup
    .string()
    .email('El email no es válido')
    .max(255)
    .required('El email es obligatorio'),
  password: yup
    .string()
    .max(255)
    .required('La contraseña es obligatoria')
});

export default credentialsSchema;
